<template>
  <b-overlay>
    <b-button-toolbar class="my-3">
      <b-input-group prepend="Jaren">
        <b-radio-group 
          v-model="jaar" 
          :options="documentJaren"
          button-variant="dark"
          buttons
        />
      </b-input-group>
      <b-input-group 
        prepend="Types" 
        class="mx-3"
      >
        <b-radio-group 
          v-model="type" 
          :options="[{text:'Alle',value: null}].concat(documenten.map(d => d.Type.Omschrijving).filter((v, i, a) => a.indexOf(v) === i))"
          buttons
          button-variant="dark"
        />
      </b-input-group>
    </b-button-toolbar>
    
    <b-table 
      :items="filteredDocuments" 
      :fields="['Datum','Document','Kenmerk','Type','Opmerkingen','Omschrijving',{
        key:'Download',
        label: 'Opties'
      }]" 
      :busy="servicebusy" 
      bordered
      fixed
      hover
      dark
      striped
      empty-text="geen documenten"
      responsive
    >
      <template #table-busy>
        <div class="text-center text-secondary m-2">
          <b-spinner 
            class="align-middle mr-2" 
          />
          <strong>Loading...</strong>
        </div>
      </template>
      <template #cell(Document)="row">
        <CopyText :text="row.item.Filename" />

        <span v-if="row.item.FileMetadata">
          <b-badge 
            v-for="t in row.item.FileMetadata.tags" 
            :key="t" 
            variant="info"
          >{{ t }}</b-badge>
        </span>
      </template>
      <template 
        #cell(Download)="row" 
      >
        <b-button-group>
          <b-button 
            v-if="row.item.FileMetadata"
            :href="row.item.FileMetadata.secure_url" 
            target="_blank" 
            variant="outline-light"
          >
            <i class="fa fa-download" /> Download
          </b-button> 
          <b-button 
            :to="{name:'Document',params:{id:row.item.Id, jaar: moment(row.item.Datum).year()}}" 
            variant="outline-light"
          >
            Ga naar document <i class="fa fa-arrow-right" />
          </b-button>
        </b-button-group>
      </template>
      <template #cell(Status)="row">
        {{ row.item.Status.Omschrijving }}
      </template>
      <template #cell(Type)="row">
        {{ row.item.Type.Omschrijving }} 
        <!-- {{ row.item.AantalUnits }} -->
      </template>
      <template #cell(Opmerkingen)="row">
        <b-list-group>
          <b-list-group-item 
            v-for="(opm,index) in row.item.Opmerkingen" 
            :key="index"
          >
            {{ opm.Opmerking | truncate(30,'...') }} <b-badge>{{ opm.Type }}</b-badge>
          </b-list-group-item>
        </b-list-group>
      </template>
      <template #cell(Datum)="row">
        {{ moment(row.item.Datum).format('LL') }}
      </template>
      <template #empty="scope">
        <h4>Geen bestanden</h4>
      </template>
      <template #emptyfiltered="scope">
        <h4>Geen bestanden gevonden</h4>
      </template>
    </b-table>
  </b-overlay>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import moment from 'moment';
import CopyText from '../../components/CopyText.vue';
export default {
    name: 'TabDocumenten',
    components: { CopyText },
    mixins: [serviceMixin],
    props: {
        unit: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            documenten: [],
            jaar: new Date().getFullYear(),
            type: null,
            copied: null
        };
    },
    computed: {
        url: function () {
            return `/unit/${this.$props.unit.Id}/documenten`;
        },
        documentJaren: function () {
            var jaren = [];
            if (this.documenten.length > 0) {
                jaren = this.documenten.map(d => moment(d.Datum).format('YYYY')).filter((v, i, a) => a.indexOf(v) === i);
            }
            return jaren;
        },
        filteredDocuments() {
            return this.documenten.filter(d => moment(d.Datum).format('YYYY') == this.jaar && (this.type == null || d.Type.Omschrijving == this.type));
        }
    },
    watch: {
        unit: {
            handler: function () {
                this.getDocumenten();
            },
            deep: true,
        },
    },
    mounted() {
        this.getDocumenten();
    },
    methods: {
        getDocumenten() {
            var vm = this;
            console.log(this.url);
            return this.get(this.url)
                .then(function (response) {
                console.dir(response.data);
                vm.documenten = response.data.documenten;
                vm.jaar = Math.max(...vm.documentJaren);
            })
                .catch(function (error) {
                console.log(error);
            });
        },
        copyToClipboard(text) {
            return navigator.clipboard.writeText(text);
        }
    },
}
</script>